// extracted by mini-css-extract-plugin
export default {"error-page":"ErrorPage_error-page__QSVmB","error-page__message":"ErrorPage_error-page__message__F7TY4","error-page__link":"ErrorPage_error-page__link__G97Ky"};